var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { placeholder: "请输入角色昵称", clearable: "" },
                    model: {
                      value: _vm.listPram.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.listPram, "roleName", $$v)
                      },
                      expression: "listPram.roleName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleGetRoleList($event)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "mini" },
                      on: { click: _vm.resetQuery },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              attrs: { inline: "" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "admin:system:role:save",
                            "admin:system:menu:cache:tree",
                          ],
                          expression:
                            "['admin:system:role:save','admin:system:menu:cache:tree']",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerOpenEdit(0)
                        },
                      },
                    },
                    [_vm._v("添加角色")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "header-cell-style": {
                  fontWeight: "bold",
                  background: "#f8f8f9",
                  color: "#515a6e",
                  height: "40px",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "角色编号", prop: "id", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "角色昵称",
                  prop: "roleName",
                  "min-width": "130",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", prop: "status" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm.checkPermi([
                          "admin:system:role:update:status",
                        ])
                          ? [
                              _c("el-switch", {
                                staticStyle: { width: "40px" },
                                attrs: {
                                  "active-value": true,
                                  "inactive-value": false,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleStatusChange(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.status,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "status", $$v)
                                  },
                                  expression: "scope.row.status",
                                },
                              }),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  prop: "createTime",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "更新时间",
                  prop: "updateTime",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:role:info"],
                                expression: "['admin:system:role:info']",
                              },
                            ],
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(1, scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:role:delete"],
                                expression: "['admin:system:role:delete']",
                              },
                            ],
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenDel(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.editDialogConfig.visible,
            title:
              _vm.editDialogConfig.isCreate === 0 ? "创建身份" : "编辑身份",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _vm.editDialogConfig.visible
            ? _c("edit", {
                ref: "editForm",
                attrs: {
                  "is-create": _vm.editDialogConfig.isCreate,
                  "edit-data": _vm.editDialogConfig.editData,
                },
                on: { hideEditDialog: _vm.hideEditDialog },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }